import React, { useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import AOS from "aos";

import Header from "../../components/Header";
import Footer from "../../components/Footer";

import MapboxGLMap from "./mapbox";

import icon1 from "../../assets/images/contact/Icon1.png";
import icon2 from "../../assets/images/contact/Icon2.png";
import icon3 from "../../assets/images/contact/Icon3.png";
import icon4 from "../../assets/images/contact/Icon4.png";

import "aos/dist/aos.css";
import "../../assets/styles/globals.css";
import "./styles.css";

function Contact() {
  AOS.init();
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
    });
  }, []);

  return (
    <>
      <Header />
      <div className="background-contact">
        <div className="bg-contact"></div>
        <div className="container">
          <div className="banner-contact content-contact">
            <h1>Contact Us</h1>
          </div>
        </div>
      </div>
      <Container>
        <Row className="contact-row">
          <Col
            xs={12}
            md={12}
            sm={12}
            lg={6}
            data-aos-once="true"
            data-aos="fade-in"
            data-aos-delay="100"
            data-aos-duration="1000"
          >
            <div className="contact-form">
              <input type="text" placeholder="Enter your name" />
              <input type="text" placeholder="Enter email address" />
              <input type="text" placeholder="Enter your subject" />
            </div>
          </Col>
          <Col
            xs={12}
            md={12}
            sm={12}
            lg={6}
            data-aos-once="true"
            data-aos="fade-in"
            data-aos-delay="100"
            data-aos-duration="1000"
          >
            <div className="contact-textarea">
              <textarea placeholder="Message" />
              <button type="submit"> Send Message</button>
            </div>
          </Col>
          <Col
            xs={12}
            md={12}
            sm={12}
            lg={12}
            data-aos-once="true"
            data-aos="fade-in"
            data-aos-delay="100"
            data-aos-duration="1000"
          >
            <div className="contact-info">
              <div className="info-1">
                <img src={icon1} className="icon-footer-1" alt="home" />
                <div>
                  <p>
                    Recife, Pernambuco, Brazil <br />
                    <small>Rua do Bom Jesus, n° 207</small>
                  </p>
                </div>
              </div>
              <div className="info-1">
                <img src={icon2} className="icon-footer-2" alt="tel" />
                <p>Tel: +55 81 2128-8181 </p>
              </div>
              <div className="info-1">
                <img src={icon3} className="icon-footer-3" alt="email" />
                <div>
                  <p>
                    eolica@eolica.com.br <br />
                    <small>
                      Send us your message anytime and will be happy to answer
                      you back
                    </small>
                  </p>
                </div>
              </div>
              <div className="info-1">
                <img src={icon4} className="icon-footer-4" alt="instagram" />
                <div>
                  <p>
                    {" "}
                    <a
                      href="https://www.instagram.com/eolicatec/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      @eolicatec{" "}
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
      <div className="container">
        <div className="mapbox">
          <MapboxGLMap />
        </div>
      </div>

      <Footer />
    </>
  );
}

export default Contact;
